export const LOCAL_STORAGE_STAND_KEY = 'stand';
export const LOCAL_STORAGE_CALC_STAND_KEY = 'calc-stand';
export const LOCAL_STORAGE_NEFROV_STAND_KEY = 'nefrov-stand';
export const LOCAL_STORAGE_LOGIN_FORM_KEY = 'showLoginForm';
